import type { SignInMethod } from '@/api/users'

export const PENDING_SIGN_IN_METHOD_KEY = 'pendingSignInMethod'

/** Call right before redirecting to an external OAuth provider — there's no reliable in-JS
 *  moment on the way back to call recordSession() (the callback page's lifetime is unpredictable;
 *  the final redirect isn't guaranteed to be a same-page SPA transition). sessionStorage survives
 *  any kind of same-tab navigation, hard or soft, so the method is stashed here and picked up by
 *  <PendingSessionRecorder/> once the user is actually signed in, wherever they land. */
export function markPendingSignInMethod(method: SignInMethod) {
  sessionStorage.setItem(PENDING_SIGN_IN_METHOD_KEY, method)
}
